import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  span {
    text-align: center;
    font-weight: 700;
    font-size: 24px;
  }

  h3 {
    font-size: 1.6em;
    margin-bottom: 22px;
    text-align: center;
  }
  .icon {
    display: flex;
    justify-content: center;
  }
  .button {
    flex: 1;
    margin: auto;
    width: 40%;
  }

  .container-detail {
    display: flex;
    justify-content: center;
  }

  .details {
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    margin-bottom: 4rem;
    text-align: start;
    color: rgba(74, 75, 74, 1);
    width: 40%;

    h2 {
      font-weight: 500;
      font-size: 20px;
      margin: 2rem 0;
    }

    div {
      margin: 8px 0px;
      font-size: 18px;
      font-weight: 400;
    }
  }
`;
